import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { CrewMembers } from '@events/models/crew-member.interface'
import { Assignee } from '@workspaces/models/assignee.interface'
import { InviteItemCardComponent } from '../invite-item-card/invite-item-card.component'
/**
 * List of crew invite items
 */
@Component({
  selector: 'ngx-invite-list',
  templateUrl: './invite-list.component.html',
  styleUrls: ['./invite-list.component.scss'],
  standalone: true,
  imports: [CommonModule, InviteItemCardComponent]
})
export class InviteListComponent {
  /**
   * Current event slug
   */
  @Input()
  eventId: number
  /**
   * Currently assigned non workspace members
   */
  @Input()
  assignedMembers: CrewMembers = []
  /**
   * Currently assigned workspace members
   */
  @Input()
  assignedWorkspaceMembers: CrewMembers = []
  /**
   * Currently unassigned workspace members
   */
  @Input()
  unassignedWorkspaceMembers: Assignee[] = []
}
